import { render, staticRenderFns } from "./BlGasParam.vue?vue&type=template&id=2b33fe32"
import script from "./BlGasParam.vue?vue&type=script&lang=js"
export * from "./BlGasParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports